































































import Vue from "vue";
import { fieldRequired, validEmail } from "@/lib/rules";
import { OrejasUser, Role, availableRoles } from "@/store/users";
import { mapState, mapGetters } from "vuex";
import { pick, cloneDeep } from "lodash-es";
import { Customer } from "../../entities/customer";
import store from "../../store";
import { handleStoreError } from "../../lib/error";

type roleSelect = {
  value: string;
  text: string;
};

const roles = Object.entries(availableRoles).map<roleSelect>(
  ([value, text]) => ({
    value: value,
    text: text as string,
  })
);

type UserCustomerWithRole = {
  name: string;
  email: string;
  uid: string;
  role: string;
};

export default Vue.extend({
  components: {},
  data() {
    return {
      name: "",
      email: "",
      uid: "",
      validForm: false,
      role: {
        value: "customerUser",
        text: availableRoles.customerUser,
      } as roleSelect,
      saving: false,
      nameRule: Object.freeze([fieldRequired("Nombre")]),
      emailRules: Object.freeze([fieldRequired("Email"), validEmail()]),
    };
  },
  props: {
    userId: {
      type: Number,
    },
  },
  created() {
    if (this.user) {
      const r = this.user.customerCurrent.role;
      this.name = this.user.name;
      this.email = this.user.email;
      this.uid = this.user.uid!;
      this.role = { value: r, text: availableRoles[r] };
    }
  },
  computed: {
    ...mapGetters("auth", ["isSuperAdmin"]),
    ...mapState("users", ["users"]),
    title(): string {
      if (this.user) {
        return `Editando usuario: ${this.user.name}`;
      }
      return "Nuevo usuario";
    },
    roles(): roleSelect[] {
      if (this.isSuperAdmin) {
        return roles;
      }
      return roles.filter((r: roleSelect) => r.value != "superAdmin");
    },
    allowSave(): boolean {
      return !this.saving && this.validForm;
    },
    user(): OrejasUser | undefined {
      if (!this.userId) {
        return undefined;
      }
      const u = this.users?.find((u: OrejasUser) => u.id == this.userId);
      return u;
    },
  },
  methods: {
    async save() {
      this.saving = true;
      let saveUser = {
        name: this.name,
        email: this.email,
        role: this.role.value,
      };
      try {
        if (this.userId) {
          saveUser = Object.assign({}, saveUser, { uid: this.uid });
          await this.$store.dispatch("users/updateUser", saveUser);
        } else {
          await this.$store.dispatch("users/createUser", saveUser);
        }
        this.$router.push("/users");
        this.saving = false;
      } catch (err) {
        this.saving = false;
      }
    },
    roleText(r: Role): string {
      return availableRoles[r];
    },
  },
});
